







import { Component, Vue } from "vue-property-decorator";
import PrettyBackground from "../components/PrettyBackground.vue";

@Component({
  components: { PrettyBackground },
})
export default class Auth extends Vue {}
